import "./Landing.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/layout/Header";
import { Body } from "../../components/landing/Body";
import { Footer } from "../../components/landing/Footer";
import { LoginModal } from "../../components/common/LoginModal";
import { validateEmail } from "./utils/validateEmail";
import { API_BASE_URL } from "../../App";
import { useLogin } from "../../hooks/useLogin";
import { useGlobal } from "../../context/GlobalContext";

interface LandingProps { }

export function Landing({ }: LandingProps) {
    const [showModal, setShowModal] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const { login } = useLogin();
    const { userKey, isLoading } = useGlobal();
    const navigate = useNavigate();

    const handleDemoClick = () => setShowModal(true);
    const handleModalClose = () => setShowModal(false);
    const handleLoginClick = () => {
        if (!isLoading && userKey) {
            navigate('/overview');
        } else {
            setShowLoginModal(true);
        }
    };
    const handleLoginModalClose = () => setShowLoginModal(false);

    const handleSignupClick = async (email: string) => {
        const isEmailValid = validateEmail(email);
        if (!isEmailValid) {
            alert(`Please enter a valid email. Entered: ${email}`);
            return;
        }

        const joinWaitlistUrl: string = `${API_BASE_URL}/webapp/waitlist`;
        await fetch(joinWaitlistUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
        });
    };

    return (
        <div className="landing-page">
            <Header onBookDemoClick={handleDemoClick} onLogin={handleLoginClick} />
            <Body
                showModal={showModal}
                onModalClose={handleModalClose}
                onWaitlistClick={handleSignupClick}
            />
            <Footer />
            {showLoginModal && (
                <LoginModal onClose={handleLoginModalClose} onLogin={login} />
            )}
        </div>
    );
}
